// TODO: need to split flows based on role and update fetchingMiddleware to handle only current role flows

import basicFlows from './basic';
import profileFlows from './profile';
import employerFlows from './employer';
import publicFlows from './public';
import jobsFlows from './jobs';

export default { ...basicFlows, ...profileFlows, ...employerFlows, ...publicFlows, ...jobsFlows };
